import React, { useRef } from "react";
import { Button, Form } from "react-bootstrap";
import ListProduct from "../ListProduct";

export default function ProductInput(
    {productList, handleProductAdd, handleProductRemove} :
    {productList: string[], handleProductAdd: (arg0 : string) => void, handleProductRemove: (arg0 : string) => void}) 
{
    
    const productRef = useRef<HTMLInputElement>(null);

    const handleAdd = () => {
        if(productRef.current?.value)
        {
            handleProductAdd(productRef.current?.value);
        }
    }

    return (
        <Form.Group  className="form-group trigger-items">
            <Form.Label className="form-label" htmlFor="mailing-trigger-criteria-items">Critères du déclencheur</Form.Label>
            <ListProduct productList={productList} handleProductRemove={handleProductRemove}/>
            <div className="form-addItem">
                <Form.Label className="form-label" htmlFor="mailing-trigger-criteria-addCriteria">Ajouter un critère au déclencheur</Form.Label>
                <Form.Control type="text" className="form-control" id="mailing-trigger-criteria-addCriteria" tabIndex={7} placeholder="" ref={productRef}/>
                <Button type="button" className="btn btn-primary btn-sm btn-add" tabIndex={8} title="Ajouter le(s) critère(s) au déclencheur" onClick={handleAdd}>
                    <span className="icon"></span>
                    <span className="text">Ajouter</span>
                </Button>
            </div>
        </Form.Group >
    )

}